<template lang="pug">
  div.page--login.page
    page-header.page-header--login(
      :breadcrumb-only="true"
      header-background="/img/frontend/page/page-header-default-background.jpg"
    )
    .container
      .row.justify-content-center.auth-form
        .col-lg-5
          login
        .col-lg-5
          register
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import BreadcrumbsManager from '../../mixins/BreadcrumbsManager';
import Login from '../../components/auth/Login.vue';
import Register from '../../components/auth/Register.vue';
import PageHeader from '../../components/layouts/PageHeader.vue';

export default {
  components: {
    Login,
    Register,
    PageHeader,
  },
  mixins: [validationMixin, BreadcrumbsManager],
  metaInfo() {
    return {
      title: Lang.get('labels.frontend.auth.breadcrumb_title'),
    };
  },
  created() {
    this.setBreadcrumbs([
      { name: Lang.get('labels.frontend.auth.breadcrumb_title') },
    ]);
  },
};
</script>
